import type { Definition } from '@exodus/dependency-types';

const createKeyViewer = ({ passkey }) => {
  const exportPrivateKey = async ({
    assetName,
  }: {
    assetName: string;
  }): Promise<any> => {
    await passkey.exportPrivateKey({
      assetName,
    });
  };

  return {
    exportPrivateKey,
  };
};

export type KeyViewer = ReturnType<typeof createKeyViewer>;

const keyViewerDefinition = {
  id: 'keyViewer',
  type: 'module',
  factory: createKeyViewer,
  dependencies: ['passkey'],
} as const satisfies Definition;

export default keyViewerDefinition;
